/**
 * Whether this browser has been asked for the first call (spec 2026-10-14
 * §3.1, §6.2): in onboarding, or by the first-open ask. Asked once; "Not now"
 * is fine and is never asked again here. A light module of its own, so the
 * onboarding beat marks it without loading the dialog.
 */
export const PHONE_ASKED_KEY = "bash.phone.asked";

export function markPhoneAsked(): void {
  try {
    window.localStorage.setItem(PHONE_ASKED_KEY, "1");
  } catch {
    /* storage blocked: the ask may come once more, nothing worse */
  }
}

/** A browser whose storage is blocked counts as asked: better silent than asking on every load. */
export function phoneAsked(): boolean {
  try {
    return window.localStorage.getItem(PHONE_ASKED_KEY) === "1";
  } catch {
    return true;
  }
}
